export const openAdvancePaymentBillTab = (applicationId) => {
    const query = applicationId
        ? `?applicationId=${encodeURIComponent(applicationId)}`
        : '';

    // Auth lives in sessionStorage (per-tab). Bridge a copy so the new bill tab
    // can rehydrate without being treated as a fresh/closed-tab logout.
    try {
        const persistRoot = sessionStorage.getItem('persist:root');
        if (persistRoot) {
            localStorage.setItem('eops:billTabAuthBridge', persistRoot);
            localStorage.setItem('eops:billTabAuthBridgeAt', String(Date.now()));
        }
    } catch (e) {
        // ignore
    }

    const opened = window.open(
        `${window.location.origin}/advance-payment-bill${query}`,
        '_blank'
    );

    if (!opened) {
        try {
            localStorage.removeItem('eops:billTabAuthBridge');
            localStorage.removeItem('eops:billTabAuthBridgeAt');
        } catch (e) {
            // ignore
        }
        window.alert('Please allow pop-ups to open the Advance Payment bill.');
    }
};
